import React from 'react';

export const GRAPHQL_URI = 'https://yourthreads.myshopify.com/api/graphql';
export const STOREFRONT_TOKEN = '88926913da2e5a38851399a9919a00a5';
export const SHOP_URL = 'yourthreads.myshopify.com'
export const SHOP_NAME = 'yourthreads'

export const GRAPHQL_URI_CAD = 'https://yourthreads-cad.myshopify.com/api/graphql';
export const STOREFRONT_TOKEN_CAD = '9e6d178dc38e9feb634889ac6ee8cf45';
export const SHOP_URL_CAD = 'yourthreads-cad.myshopify.com'
export const SHOP_NAME_CAD = 'yourthreads-cad'



export const COLOR_MAP = {
	ivory: {
		color: '#E7CEA9',
		contrast: true
	},
	tan: {
		color: '#D7B17A',
		contrast: true
	},
	caramel: {
		color: '#84593D',
		contrast: true
	},
	espresso: {
		color: '#522D16',
		contrast: true
	},
	black: {
		color: '#414141',
		contrast: true
	}
}


export const VARIANT_NAME_MAPPING = {
	'threads-1a': '0-opaque',
	'threads-1b': '1-opaque',
	'threads-2a': '0-opaque',
	'threads-2b': '1-opaque',
	'threads-2c': '2-opaque',
	'threads-3a': '0-opaque',
	'threads-3b': '1-opaque',
	'threads-3c': '2-opaque',
	'threads-3d': '3-opaque',
	'0-opaque': '0-opaque',
	'1-opaque': '1-opaque',
	'2-opaque': '2-opaque',
	'3-opaque': '3-opaque'
}

export const VARIANT_OPAQUE_QUANTITY = {
	'threads-1a': 0,
	'threads-1b': 1,
	'threads-2a': 0,
	'threads-2b': 1,
	'threads-2c': 2,
	'threads-3a': 0,
	'threads-3b': 1,
	'threads-3c': 2,
	'threads-3d': 3,
	'0-opaque': 0,
	'1-opaque': 1,
	'2-opaque': 2,
	'3-opaque': 3
}
